import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from "@mui/material";
import { clearToken } from "../services/authService";

const SessionExpiredDialog = ({ open }) => {
  const handleClose = () => {
    clearToken();

    const FRONTEND_URL =
      process.env.REACT_APP_FRONTEND_URL || window.location.origin;

    window.location.href = `${FRONTEND_URL}`; // ✅ Dev: http://localhost:3000/login, Prod: https://yourdomain.com/login
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="session-expired-title"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="session-expired-title">Session Expired</DialogTitle>
      <DialogContent>
        <DialogContentText>
          ⏰ Your session has expired for security reasons.  
          Please login again to continue.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          variant="contained"
          sx={{
            borderRadius: 2,
            color: "white",
            backgroundColor: "#4D99A3",
            border: "none",
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "scale(1.05)",
            },
          }}
        >
          Login Again
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpiredDialog;
